<div class="container layout-row gap-3percent">
  <mat-card class="client-card layout-column flex gap-2px">
    <mat-form-field class="flex-30">
      <mat-label>{{ 'labels.inputs.Add Clients' | translate }}</mat-label>
      <input matInput [formControl]="clientChoice" [matAutocomplete]="clientsAutocomplete" />
    </mat-form-field>

    <mat-autocomplete autoActiveFirstOption #clientsAutocomplete="matAutocomplete" [displayWith]="displayClient">
      @for (client of clientsData; track client) {
        <mat-option [value]="client">
          {{ client.displayName }}
        </mat-option>
      }
    </mat-autocomplete>

    <div class="mat-table">
      <div class="mat-header-row">
        <div class="mat-header-cell">{{ 'labels.inputs.Client Details' | translate }}</div>
        <button mat-icon-button (click)="addClient()">
          <fa-icon icon="plus"></fa-icon>
        </button>
      </div>
      <div class="mat-row">
        <div class="mat-cell">{{ 'labels.inputs.name' | translate }}</div>
        <div class="mat-cell">{{ clientChoice.value.displayName }}</div>
      </div>
      <div class="mat-row">
        <div class="mat-cell">{{ 'labels.inputs.Id' | translate }}</div>
        <div class="mat-cell">{{ clientChoice.value.id }}</div>
      </div>
      <div class="mat-row">
        <div class="mat-cell">{{ 'labels.inputs.Office' | translate }}</div>
        <div class="mat-cell">{{ clientChoice.value.officeName }}</div>
      </div>
    </div>
  </mat-card>

  <mat-card class="flex-50">
    <h3 matSubheader>{{ 'labels.heading.Client Members' | translate }}</h3>

    @if (clientMembers?.length) {
      <mat-nav-list>
        @for (client of clientMembers; track client; let i = $index) {
          <div mat-list-item>
            <span matLine class="p-t-10">{{ client.displayName }}</span>
            <div class="flex-fill"></div>
            <button
              mat-icon-button
              color="warn"
              (click)="removeClient(i, client)"
              matTooltip="{{ 'tooltips.Remove Client from Group' | translate }}"
              matTooltipPosition="left"
            >
              <fa-icon icon="trash"></fa-icon>
            </button>
          </div>
        }
      </mat-nav-list>
    }
  </mat-card>
</div>
